// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as PayoutActions } from '../duck';
import { actions as AlertActions } from '../../../alert/duck';
import Payouts from '../components/Payouts';

import type { RootState } from '../../../index';

function mapStateToProps(state: RootState) {
  return {
    isPostingPayout: state.preferences.payouts.isPostingPayout,
    isDeletingPayout: state.preferences.payouts.isDeletingPayout,
    payouts: state.preferences.payouts.payouts,
    successDelete: state.preferences.payouts.successDelete,
    postPayoutError: state.preferences.payouts.postPayoutError,
    deletePayoutError: state.preferences.payouts.deletePayoutError,
    localValues: state.localValues,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ ...PayoutActions, ...AlertActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Payouts);



// WEBPACK FOOTER //
// ./src/modules/preferences/payouts/containers/PayoutsContainer.js